module.exports = __webpack_public_path__ + "img/jjh_common.3df49f51.png";